/**
 * CSRF helpers.
 *
 * v2-only: the new admin BE manages CSRF via its own session cookie, so the
 * legacy XSRF-TOKEN bootstrap (`POST /api3/campaigns/getEnvironment`) is no
 * longer performed. `ensureCsrfSession` is a no-op, retained so the shared
 * error-retry paths in the API adapters can call it unconditionally.
 * `readXsrfCookie` still reads the cookie for any legacy request headers.
 */

export function readXsrfCookie(): string {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}

/**
 * No-op in the v2-only setup (the new BE handles CSRF itself). Kept as an async
 * function so the adapter retry paths can `await ensureCsrfSession(true)`.
 */
export async function ensureCsrfSession(_force = false): Promise<void> {
  return;
}
